import {
  useSubscription,
  type SubscriptionResponse,
  type UseSubscriptionOptions,
  type UseSubscriptionReturn,
} from '@talos/kyoko';
import { CM_WEBSOCKET_CLIENT_KEY } from './coinMetricsConstants';
import type { CoinMetricsRequestStream, CoinMetricsTickPayload } from './coinMetricsSubscriptionMerge';

/**
 * Strongly-typed entry point for subscribing through `CoinMetricsWebSocketClient`. Prefer this over
 * calling `useSubscription(request, { client: CM_WEBSOCKET_CLIENT_KEY })` directly: the generic
 * `useSubscription` has no way to require this client's own `frequency` field just because `client` is
 * `'cm'`, so a plain `{ name, tag }` RequestStream compiles fine there and only fails at runtime (see
 * `CoinMetricsWebSocketClient`'s own registration-time validation, which stays as the defense-in-depth
 * backstop for a caller that bypasses this hook). Typing `request` as `CoinMetricsRequestStream` here
 * makes a missing `frequency` a compile error instead.
 */
export function useCoinMetricsSubscription(
  request: CoinMetricsRequestStream | CoinMetricsRequestStream[] | null,
  options?: Omit<UseSubscriptionOptions, 'client'>
): UseSubscriptionReturn<SubscriptionResponse<CoinMetricsTickPayload>> {
  return useSubscription<CoinMetricsTickPayload>(request, { ...options, client: CM_WEBSOCKET_CLIENT_KEY });
}
